"use client";
import axios from "axios";
import { useEffect, useState } from 'react';

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import AppBar from "@mui/material/AppBar";
// import Drawer from '@mui/material/Drawer';
import Toolbar from "@mui/material/Toolbar";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
// import Scrollbar from '../components/scrollbar';
import { Button, Card, Drawer, IconButton, } from "@mui/material";
import { Tooltip } from '@mui/material';
import { MegaMenuDesktopVertical } from "../components/mega-menu";
// import megaconnectLogo from "../assets/images/MegaconnectLOGO-06.png";

// import { paths } from 'src/routes/paths';
// import { usePathname } from 'src/routes/hooks';
import Iconify from "../components/iconify";
import Image from "../components/image";
// import { useBoolean } from 'src/hooks/use-boolean';

import megaconnectLogo from "../assets/images/banner.svg";
import BannerWhite from "../assets/images/bannerwhite.svg";
import { paths } from "../routes/paths";
import { Outlet, useLocation } from "react-router-dom";
import { useResponsive } from "../hooks/use-responsive";
import Scrollbar from "../components/scrollbar";
import AccountPopover from "../layouts/account-popover";
import { useBoolean } from "../hooks/use-boolean";
import MegaMenuMobile from "../components/mega-menu/mobile/mega-menu-mobile";
import { useSnackbar } from "../../src/components/snackbar";
import DeleteAccount from "./DeleteAccount";


// ----------------------------------------------------------------------

export default function MegaMenuView() {
  const SERVER_URI = process.env.REACT_APP_SERVER_URI;
  const GET_USER = `${SERVER_URI}/user`;
  const DELETE_ACCOUNT = `${SERVER_URI}/delete-account`
  const location = useLocation();
  const mdUp = useResponsive("up", "md");
  // const pathname = usePathname();
  const deleteUser = useBoolean();
  const mobileOpen = useBoolean();
  const { enqueueSnackbar } = useSnackbar();
  useEffect(() => {
    if (mobileOpen) {
      mobileOpen.onFalse();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const [userName, setUserName] = useState("")

  useEffect(() => {
    let token = localStorage.getItem("accessToken");
    let config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    axios
      .get(GET_USER,
        config,
        {
          withCredentials: true,
        })
      .then((response) => {
        setUserName(response?.data?.user?.username)
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);


  const handleDownload = () => {
    window.location.href = "/downloadwin"
  };

  const handleDeleteAccount = async () => {
    let token=localStorage.getItem("accessToken")
    let config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    try {
      const response = await axios.delete(DELETE_ACCOUNT, config, {
        withCredentials: true, // Send cookies with the request
      });
      
      if (response.status === 200) {
        enqueueSnackbar(response.data.message, { variant: "success" });
        setTimeout(()=>{
          window.location.href = "/";
        },2000)
     }
    } catch (error) {
      console.error("Failed to delete account:", error);
      enqueueSnackbar("Error deleting account. Please try again.");
    }
  };
  const handleDeleteUserClick = () => {
    mobileOpen.onFalse(); // First, close mobileOpen
    setTimeout(() => {
        deleteUser.onTrue(); // Then, trigger deleteUser
    }, 0); // Using a delay of 0 ensures the two actions are sequential
};
  const renderMobile = (
    <>

      <IconButton
        onClick={mobileOpen.onTrue}
        sx={{
          color: 'blue',
          background: (theme) => theme.palette.background.default,
          '&:hover': {
            background: (theme) => theme.palette.action.hover,
          },
        }}
      >
        <Iconify icon="quill:hamburger" width="1.5em" height="1.5em" />
      </IconButton>


      <Drawer
        anchor="right"
        open={mobileOpen.value}
        onClose={mobileOpen.onFalse}
        PaperProps={{
          sx: {
            pb: 5,
            width: {
              xs: 320, // Width when the screen size is small (less than 600px)
              sm: 350, // Width when the screen size is medium or larger (600px and above)
            },
            pl:2,
            backgroundColor: '#1d53e7',
            borderTopLeftRadius: 25, // Only the top-left corner radius
            borderBottomLeftRadius: 25, // Only the bottom-left corner radius
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 1.50)', // Shadow styling
          },
        }}
      >
        {/* <Scrollbar> */}
        {/* <Logo sx={{ mx: 2.5, my: 3 }} /> */}
        <Image
          src={BannerWhite}
          sx={{ mx: 2.5, my: 3, maxWidth: "120px" }}
        />
        <MegaMenuMobile data={NAV_ITEMS} />
        <Box sx={{ flexGrow: 1 }} />

        {/* Buttons at the bottom */}
        <Box sx={{ p: 1 }} >
          <Button
            size="large"
            fullWidth
            sx={{
              justifyContent: "left",
              backgroundColor: "#FFFFFF",
              color: "black",
              mb: 1,

              fontWeight: 600,
              textTransform: "none",
              "&:hover": {
                backgroundColor: "#FFFFFF",
                transform: "scale(1.05)",
                color: "#black",
                fontWeight: 600,
              },
            }}
            onClick={handleDownload}
          >
            <Stack>
              <Iconify icon="material-symbols:download" sx={{ color: "#1D53E7" }} />
            </Stack>{" "}
            &nbsp; Download Desktop App
          </Button>
          <Button
            size="large"
            fullWidth
            sx={{
              justifyContent: "left",
              backgroundColor: "#FFECEC",
              color: "#F03D55",
              mb: 1,
              fontWeight: 600,
              textTransform: "none",
              "&:hover": {
                backgroundColor: "#FFECEC",
                transform: "scale(1.05)",
                color: "#F03D55",
                fontWeight: 600,
              },
            }}
            // onClick={handleDeleteAccount}
            onClick={handleDeleteUserClick}
          >
            <Stack>
              <Iconify icon="mingcute:delete-line" />
            </Stack>{" "}
            &nbsp; Delete Account
          </Button>
        </Box>

        {/* </Scrollbar> */}
      </Drawer>
    </>
  );


  const renderHorizontal = (
    <AppBar
    position={mdUp ? 'static' : 'sticky'}
    color='transparent'
    sx={{
      height: 79,
      boxShadow: '0px 3px 7px rgba(125, 125, 125, 0.20)',  // Apply shadow only when sticky
      top: 0, // Ensures it sticks to the top of the screen when sticky
      zIndex: (theme) => theme.zIndex.appBar + 1, // Layer control for stickiness
      backgroundColor: 'white',
      transition: 'box-shadow 0.3s ease, background-color 0.3s ease', // Smooth transition
    }}
    >
      <Toolbar
        component={Container}
        maxWidth={false}
        sx={{ height: 1, px: { lg: 5 } }}
      >
        <Image
          src={megaconnectLogo}
          sx={{ mx: 2.5, my: 3, maxWidth: "120px" }}
        />
        <Stack
          flexGrow={1}
          direction="row"
          alignItems="center"
          justifyContent="flex-end"
          spacing={{ xs: 0.5, sm: 1 }}
        >
          {mdUp && <AccountPopover userName={userName} />}
          {!mdUp && renderMobile}
        </Stack>

      </Toolbar>
    </AppBar>
  );

  const renderVertical = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': {
          height: 1,
          display: 'flex',
          flexDirection: 'row',
        },
      }}
    >
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="center"
        spacing={8}
        sx={{
          pl: 1,
          // zIndex: 1000,
          position: "relative",
          overflow: 'auto'
        }}
      >
        <Card
          sx={{
            width: "280px",
            minHeight: 420,
            p: 3,
            backgroundColor: "#1D53E7",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            borderRadius: 5, // Add sticky positioning
            position: "relative",
            overflow: 'auto'
            // Add a high z-index to ensure it stays on top
          }}
        >
          <>
            {/* Menu Component */}
            <MegaMenuDesktopVertical data={NAV_ITEMS} />
          </>

          {/* Spacer to push content down */}
          <Box sx={{ flexGrow: 1 }} />

          {/* Buttons at the bottom */}
          <Box>
            <Button
              size="large"
              fullWidth
              sx={{
                justifyContent: "left",
                backgroundColor: "#FFFFFF",
                color: "black",
                mb: 1,
                fontWeight: 600,
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#FFFFFF",
                  transform: "scale(1.05)",
                  color: "#black",
                  fontWeight: 600,
                },
              }}
              onClick={handleDownload}
            >
              <Stack>
                <Iconify icon="material-symbols:download" sx={{ color: "#1D53E7" }} />
              </Stack>{" "}
              &nbsp; Download Desktop App
            </Button>
            <Button
            size="large"
            fullWidth
            sx={{
              justifyContent: "left",
              backgroundColor: "#FFECEC",
              color: "#F03D55",
              mb: 1,
              fontWeight: 600,
              textTransform: "none",
              "&:hover": {
                backgroundColor: "#FFECEC",
                transform: "scale(1.05)",
                color: "#F03D55",
                fontWeight: 600,
              },
            }}
            // onClick={handleDeleteAccount}
            onClick={deleteUser.onTrue}
          >
            <Stack>
              <Iconify icon="mingcute:delete-line" />
            </Stack>{" "}
            &nbsp; Delete Account
          </Button>
          </Box>
        </Card>

      </Stack>
    </Scrollbar>
  );


  return (
    <>
      {renderHorizontal}
      {!mdUp && <Stack
          direction="row"
          spacing={{ xs: 0.5, sm: 1 }}
          sx={{paddingLeft: '114px', paddingRight: '114px', paddingTop: '16px', paddingBottom: '16px', background: 'white', justifyContent: 'center', alignItems: 'center' }}
        >
          
     <AccountPopover userName={userName} />
      </Stack>}
      <Box
        sx={{
          minHeight: 1,
          display: "flex",
          flexDirection: { xs: "row", lg: "row" },
        }}
      >
        {/* {renderMobile} */}
        {/* {mdUp && <Box pb={5}>{renderVertical}</Box>} */}
        {mdUp && (
          <Box
            pb={5}
            sx={{
              mt:'10px',
              position: { lg: 'sticky', md: 'sticky' },
              top: 50, // Stick to the top of the viewport
              height: '120vh', // Full height of the viewport
              overflowY: 'visible', // Enable scrolling within this section if content overflows
            }}
          >
            {renderVertical}
          </Box>
        )}


        <Container maxWidth={false} sx={{mt:'10px'}}>
          <Outlet />
        </Container>
      </Box>
      <DeleteAccount  isOpen={deleteUser.value}  onClose={deleteUser.onFalse}  userName={userName && userName}/>
    </>
  );
}

// ----------------------------------------------------------------------

const NAV_ITEMS = [
  {
    title: "Dashboard",
    path: paths.dashboard.home ,
    icon: (
      <Iconify
        icon="material-symbols:dashboard-outline"
        sx={{ width: 1, height: 1 }}
      />
    ),
  },
  {
    title: "Profile",
    path: paths.dashboard.dashProfile,
    icon: <Iconify icon="gg:profile" sx={{ width: 1, height: 1 }} />,
  },
  {
    title: "Plans",
    path: paths.dashboard.dashPlans,
    icon: <Iconify icon="lets-icons:dimond-alt" sx={{ width: 1, height: 1 }} />,
  },
  {
    title: "Support",
    path: paths.dashboard.dashSupport,
    icon: <Iconify icon="mdi:handshake-outline" sx={{ width: 1, height: 1 }} />,
  },
  {
    title: "Refer & Earn",
    path: paths.dashboard.referAndEarn,
    icon: <Iconify icon="material-symbols:currency-rupee-circle-outline-rounded" sx={{ width: 1, height: 1 }} />,
  },


];
